import { useFormikContext } from 'formik';
import { Label } from '@antimatterhq/ui/components/label';
import type { DataSourceFieldSchemaValues } from '@/zod/schemas/dataSource/DataSourceField';
import { FormError, FormSqlExpressionInput } from '@/components/form/form';

export default function SqlTab() {
  const formik = useFormikContext<DataSourceFieldSchemaValues>();

  return (
    <div className="mt-4">
      <Label htmlFor="expr" id="expr-label" required>
        Enter a SQL expression that defines a new field to be added
      </Label>
      <FormSqlExpressionInput
        name="expr"
        value={formik.values.expr || ''}
        onChange={formik.handleChange}
        onBlur={formik.handleBlur}
        aria-labelledby="expr-label"
        data-testid="sql-tab-code-editor"
      />
      <FormError name="expr" />
    </div>
  );
}
